module.exports = __webpack_public_path__ + "img/17ea0e1.png";